@if (loading()) {
  <aux-table-skeleton />
} @else {
  <div class="px-[21px] pt-[21px] text-2xl font-bold text-black">Close Summary</div>

  <aux-table-panel class="mb-[21px] p-[21px]">
    <div
      class="flex items-center gap-4 bg-[#FFCA80] p-4"
      [class.hidden]="periodCloseComponent.currencyToggle() === 'contracted'"
    >
      <div
        class="size-[14px] rounded-full"
        data-pendo-tooltip-container="close-summary-numbers-converted-to-us-dollar"
      ></div>
      <div class="font-medium">Close Summary numbers converted to US Dollar ($).</div>
    </div>
    <div class="flex items-center justify-between p-4">
      <div>
        @if (periodCloseComponent.showCurrencyToggle()) {
          <div class="flex items-center space-x-2">
            <div>USD</div>
            <aux-toggle
              [value]="periodCloseComponent.currencyToggle() === 'contracted'"
              (change)="onCurrencyChange($event ? 'contracted' : 'usd')"
              [disabled]="!!isCurrencyToggleDisabled()"
              [auxTooltip]="isCurrencyToggleDisabled()"
              [class.opacity-50]="!!isCurrencyToggleDisabled()"
            />
            <div>Vendor Contract Currency</div>
          </div>
          <aux-exchange-link class="[&_.exchange-link]:p-0" />
        }
      </div>
      <div class="flex items-center gap-[15px]">
        @if (quarterCloseService.isFluxAnalysisAvailable()) {
          <div class="flex items-center space-x-2">
            <aux-toggle
              [value]="fluxAnalysisMode()"
              [pendoId]="'flux-analysis-toggle'"
              (change)="toggleFluxAnalysisMode($event)"
              [disabled]="!!isFluxDisabled()"
              [auxTooltip]="isFluxDisabled()"
              [class.opacity-50]="!!isFluxDisabled()"
            />
            <div>Flux Analysis</div>
          </div>
        }
        <aux-button
          variant="hyperlink"
          label="Clear All"
          classList="p-0"
          (clickEmit)="clearFilters()"
        />

        <aux-qc-download-vendor-estimate />

        <aux-button
          variant="secondary"
          label="Send Vendor Estimate Support"
          (clickEmit)="onAddVendorEstimateUploadClick()"
        />

        <aux-export-excel-button
          [clickFN]="onExport.bind(this)"
          [spinnerSize]="7"
          pendoTag="quarter-close-excel-export-button"
        />
      </div>
    </div>

    <aux-qc-table
      #table
      [stickyServiceOffset]="stickyServiceOffset()"
      [rowData]="periodCloseComponent.newQCGridData()"
      [isCloseMonthAvailable]="isCloseMonthAvailable()"
    />
  </aux-table-panel>
}

@if (showBanner()) {
  <aux-quarter-close-banner
    [disabled]="!isCloseMonthAvailable()"
    [currentMonth]="periodCloseComponent.currentMonthSignal()"
    (closeMonth)="tableComponent()!.onInMonthClose()"
    [hasClosePermission]="permissions().closeMonth"
  />
}
